import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from "@angular/router";



@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {

  token=null;

  constructor(private router: Router) { }

  canActivate(){
    if(this.token != undefined || this.token != null ){
      return true;
    }else{
        this.router.navigate(['home']);
        return false;
    }
}




}
